import request from '@/utils/request'
const context = require('./context')

export function fetchList(params) {
  return request({
    url: context.EEOP + '/dict/list',
    method: 'get',
    params: params
  })
}

export function createDict(flag,data) {
  return request({
    url: context.EEOP + '/dict/createDict/' + flag,
    method: 'post',
    data: data
  })
}

export function updateDict(data) {
  return request({
    url: context.EEOP + '/dict/updateDict',
    method: 'post',
    data: data
  })
}

export function updateStatus(id, params) {
  return request({
    url: context.EEOP + '/dict/updateStatus/' + id,
    method: 'post',
    params: params
  })
}

export function deleteDict(id) {
  return request({
    url: context.EEOP + '/dict/delete/' + id,
    method: 'post'
  })
}

export function fetchDictListByType(params,secPrams) {
  return request({
    url: context.EEOP + '/dict/load/' + params,
    method: 'get',
    params: secPrams
  })
}
export function queryDishesFeature() {
  return request({
    url: context.EEOP + '/dict/query_dishes_feature',
    method: 'get'
  })
}
export function fetchIngredientCateList() {
  return request({
    url: context.EEOP + '/dict/query_ingredient_cate',
    method: 'get'
  })
}


// WEBPACK FOOTER //
// ./src/api/dict.js